import { h, render } from 'preact';
import Confirmation from '../../theme/dialogs/confirmation';
import Notification from '../../theme/dialogs/notification';
import { removeGiftBox } from './remove-gift-box';
import { t } from '../../theme/locales';
/**
 * Show a confirmation dialog before removing a gift box.
 * After successful removal, display a momentary notification.
 *
 * Works imperatively — can be called from Preact `onClick` handlers as well as
 * plain DOM event listeners (e.g. the delegated Liquid-rendered button).
 */ export const confirmRemoveGiftBox = (itemKey, imageUrl)=>{
    const container = document.createElement('div');
    document.body.appendChild(container);
    const cleanup = ()=>{
        try {
            render(null, container);
        } catch (_) {
        // ignore
        }
        container.remove();
    };
    const showNotification = ()=>{
        const notifContainer = document.createElement('div');
        document.body.appendChild(notifContainer);
        const closeNotification = ()=>{
            try {
                render(null, notifContainer);
            } catch (_) {
            // ignore
            }
            notifContainer.remove();
        };
        render(h(Notification, {
            open: true,
            title: t('gift_wrapping.remove.removed'),
            momentary: true,
            duration: 4000,
            onClose: closeNotification,
            imageUrl: imageUrl !== null && imageUrl !== void 0 ? imageUrl : undefined
        }), notifContainer);
    };
    const handleConfirm = async ()=>{
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        renderDialog(true);
        await removeGiftBox(itemKey);
        cleanup();
        showNotification();
    };
    const handleCancel = ()=>{
        cleanup();
    };
    const renderDialog = (loading)=>{
        render(h(Confirmation, {
            open: true,
            title: t('gift_wrapping.remove.title'),
            subtitle: t('gift_wrapping.remove.subtitle'),
            content: h('div', null, t('gift_wrapping.remove.content')),
            confirmText: t('gift_wrapping.remove.cta'),
            loadingText: t('gift_wrapping.remove.loading'),
            cancelText: t('gift_wrapping.remove.cancel'),
            disabled: loading,
            onConfirm: ()=>void handleConfirm(),
            onCancel: handleCancel
        }), container);
    };
    renderDialog(false);
};
